import { Route, Routes } from 'react-router-dom';
import { useState } from 'react';
import Headbar from './Core/Headbar/Headbar';
import TopNavbar from './Core/Navbar/TopNavbar';
import SideNavbar from './Core/Navbar/SideNavbar';
import Brochure from './Core/Brochure/Brochure';
import SocialMediaLinks from './Core/SocialMediaLinks/SocialMediaLinks';
import Footer from './Core/Footer/Footer';
import navigation from './Content/Data/Navigation/navigation.json';
import './Content/Styles/App.css';

function App() {
  const [isPathChanged, setIsPathChanged] = useState(null);
  const [openSideNavigation, setOpenSideNavigation] = useState(false);

  return (
    <div className="app">
      {/* <Headbar /> */}
      <TopNavbar isPathChanged={isPathChanged} setIsPathChanged={setIsPathChanged} openSideNavigation={openSideNavigation} setOpenSideNavigation={setOpenSideNavigation} />
      <SideNavbar isPathChanged={isPathChanged} setIsPathChanged={setIsPathChanged} openSideNavigation={openSideNavigation} setOpenSideNavigation={setOpenSideNavigation} />
      <div className='content'>
        <Routes>
          {
            navigation.map((x, i) => {
              const Component = require(`./Core/${x.component}/${x.component}`).default;
              return (
                <Route key={i} exat path={`/${x.to}`} element={<Component isPathChanged={isPathChanged} />} />
              );
            })
          }
        </Routes>
      </div>
      <Brochure isPathChanged={isPathChanged} setIsPathChanged={setIsPathChanged} />
      {/* <SocialMediaLinks /> */}
      {/* <QuickConnect /> */}
      <Footer isPathChanged={isPathChanged} setIsPathChanged={setIsPathChanged} />
    </div>
  );
}

export default App;
